import React from 'react'
import { Mutation } from "react-apollo";
import { DELETE,GET } from "../../../queries/layout_definition";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function filteredData(s, l, ls){
  s.data.forEach(d => {
    const id = ls[d.dataIndex].id;
      l = l.filter(e => e.id !== id)
    })
  return l;
}

class Delete extends React.Component {
  render(){
    const { selectedRows, layoutDefinitions } = this.props;
    return (
      <Mutation
        mutation={DELETE}
        update={(store, { data: { deleteLayoutDefinition } }) => {
          const { layoutdefinition } = store.readQuery({ query: GET });
          store.writeQuery({
            query: GET,
            data: { layoutdefinition: filteredData(selectedRows, layoutdefinition, layoutDefinitions) }
          });
        }}
        >
        {deleteLayoutDefinition => (
          <div>
            <IconButton aria-label="delete" onClick = {
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const id = layoutDefinitions[d.dataIndex].id;
                  deleteLayoutDefinition({ variables: {id: id }})  
                });
              }
            }>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
};

export default Delete;